export const COS_FILE_PROXY_PATH = '/api/xy/file/cosfile';

/** 私有文件地址携带资源所属项目，避免依赖当前标签页写入的 cookie。 */
export function buildCosFileProxyUrl({ projectId, cosId, key, isPlatformCOS = false }) {
  const query = new URLSearchParams({ projectid: projectId, cosid: cosId, key });
  if (isPlatformCOS === true) query.set('platform', '1');
  return `${COS_FILE_PROXY_PATH}?${query.toString()}`;
}

/** 后台返回的根路径代理地址需要补部署前缀；公有 URL 和已带前缀的地址保持原样。 */
export function withCosFilePathPrefix(url, pathPrefix) {
  return typeof url === 'string' && url.startsWith(`${COS_FILE_PROXY_PATH}?`)
    ? `${pathPrefix}${url}`
    : url;
}

export function getCosFileProxyKey(url) {
  try {
    const parsed = new URL(url, 'https://wuji.invalid');
    if (parsed.pathname.endsWith(COS_FILE_PROXY_PATH)) {
      return parsed.searchParams.get('key');
    }
  } catch (_) {
    // 普通文件地址继续沿用路径解析。
  }
  return null;
}

export function getFileNameFromUrl(url) {
  const key = getCosFileProxyKey(url);
  // URLSearchParams 已解码一次，不能再次解码对象 key 中的字面量百分号。
  if (key !== null) return key.split('/').pop() || '';
  try {
    const match = String(url).match(/\/([^/?#]+)(?:[?#]|$)/);
    return match ? decodeURIComponent(match[1]) : '';
  } catch (_) {
    return '';
  }
}
